mobileSize = 1000;

$(document).ready(function(){
  // Get the content of the div element
var eventDatesDiv = document.getElementById("eventDates");
var content = eventDatesDiv.textContent.trim();

// Split the content by the dash and space
var parts = content.split(" - ");

// Ensure there are at least two parts (start date and end date)
if (parts.length >= 2) {
  // Get the first word
  var firstWord = parts[0].split(" ")[0];

  // Extract the first three letters from the first word
  var firstThreeLetters = firstWord.substring(0, 3);

  // Construct the new content with the extracted letters
  var newContent = firstThreeLetters + " " + parts[0].substring(firstWord.length);

  // Update the div content with the new content
  eventDatesDiv.textContent = newContent + " - " + parts[1];
}

  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1000) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1001) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
   
});

$(window).load(function(){
  setTimeout(function() {
  // Get the content of the div element
var eventDatesDiv = document.getElementById("eventDates");
var content = eventDatesDiv.textContent.trim();

// Split the content by the dash and space
var parts = content.split(" - ");

// Ensure there are at least two parts (start date and end date)

if (parts.length >= 2) {
  // Get the first word
  var firstWord = parts[0].split(" ")[0];

  // Extract the first three letters from the first word
  var firstThreeLetters = firstWord.substring(0, 3);

  // Construct the new content with the extracted letters
  var newContent = firstThreeLetters + " " + parts[0].substring(firstWord.length);

  // Update the div content with the new content
  eventDatesDiv.textContent = newContent + " - " + parts[1];
}
}, 1000);
  $('body').addClass('pageIsLoaded');
    setInterval(function() {
      var str = $('#weatherBugDescription').text();
      var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
      if(!weatherBugSet && str != ''){
        $('#weatherBugWidget').addClass('weatherBugSet');
          var findSpace = str.lastIndexOf(' ');
          var stringLength = str.length;
          var res = str.substring(findSpace, stringLength);
          var start = str.substring(0, findSpace);
          $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
          $('#weatherBugWidget').css('visibility', 'visible');
      }
    },12);
});